@if (recipefirstLayout) {
  <div class="flex flex-row items-center gap-[0.625rem]" [ngClass]="{'lg:gap-[1.5rem]': useSummaryPageStyle}">
    <div class="w-full max-w-[4.375rem]" [ngClass]="useSummaryPageStyle ? 'md:max-w-[7rem]' : ''">
      <app-image [alt]="_line.recipe?.displayname" size="md" [src]="_line.recipe?.websitemediumimageurl" class="rounded-[1rem] h-[3.625rem] md:h-[4.875rem] object-cover" [ngClass]="useSummaryPageStyle ? 'md:block hidden' : 'hidden'"></app-image>
      <app-image [alt]="_line.recipe?.displayname" size="md" [src]="_line.recipe?.websitemediumimageurl" class="rounded-[1rem] h-[4.375rem] object-cover" [ngClass]="useSummaryPageStyle ? 'md:hidden' : ''"></app-image>
    </div>
    <div class="flex flex-grow flex-col gap-[0.2rem]" [ngClass]="useSummaryPageStyle ? 'md:flex-row md:gap-0' : ''">
      <div>
        <div [ngClass]="useSummaryPageStyle ? 'md:font-[700] md:text-e-dark-green md:text-[1.25rem]' : ''" class="text-[0.875rem] leading-[120%] mb-[0.125rem] font-[600] text-black">
          {{_line.recipe?.displayname}}
        </div>
        <div class="flex text-[0.75rem] gap-[0.25rem]" [ngClass]="useSummaryPageStyle ? 'md:text-[1rem]' : ''">
          <pricetag [calculatedPrice]="_line?.calculatedPrice" [couponcodeItem]="_line?.couponcodeitem" [compensationItem]="_line?.compensationitem" [hideSmallTag]="hidePriceSmallTag" [ngClass]="{'md:hidden': useSummaryPageStyle}"></pricetag>
          <span class="text-[#A6A6A6] block" [ngClass]="useSummaryPageStyle ? 'md:hidden' : ''">|</span>
          <span class="text-[#A6A6A6]" [ngClass]="useSummaryPageStyle ? 'md:text-e-dark-green' : ''">
            {{_line?.calculatedPrice?.priceincvat / (_line.doublepersons ? _line.persons * 2 : _line.persons) | currency : 'EUR'}} /{{'common.person_abbr'|translate}}
          </span>
        </div>
      </div>
      <div class="flex-grow flex gap-[0.3rem] items-center" [ngClass]="useSummaryPageStyle ? 'md:gap-[0.625rem] lg:gap-[1.5rem] md:justify-end' : ''">
        @if (removable) {
          <div class="order-1 md:order-3 mb-0 hidden" [ngClass]="useSummaryPageStyle ? 'md:block' : ''">
            <button class="block leading-[1] md:text-[1.75rem] text-[1rem] md:w-[1.75rem] w-[1rem]" (click)="removeRecipeline()">
              <i class="bi bi-x-circle"></i>
            </button>
          </div>
          <button class="leading-[1]" (click)="removeRecipeline()" [ngClass]="useSummaryPageStyle ? 'md:hidden block' : ''">
            <img src="./assets/images/icons/delete-recipefirst.svg" height="20px" width="20px" alt="delete" />
          </button>
        }
        @if (useSummaryPageStyle) {
          <div class="text-e-dark-green md:text-[1.25rem] text-[0.875rem] order-2 md:block hidden">
            {{_line?.calculatedPrice?.priceincvat | currency : 'EUR'}}
          </div>
        }
        <div class="flex" [ngClass]="{'md:order-1 order-3': useSummaryPageStyle}">
          <app-personselection-compact class="block" [contrastColorscheme]="colorscheme" small [persons]="_line.persons" (personsChange)="changePersonQty($event)" [editable]="removable">
            <span>{{ 'common.portions_unit' | translate: { count: (_line.doublepersons ? _line.persons * 2 : _line.persons) } }}</span>
          </app-personselection-compact>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="flex" [ngClass]="layout === 'CONDENSED' ? 'flex-col bg-white' : 'flex-row'">
    @if (layout === 'CONDENSED') {
      <div class="w-full">
        <app-image [alt]="_line.recipe?.displayname" size="md" [src]="_line.recipe?.websitemediumimageurl" class="rounded-md"></app-image>
      </div>
    } @else {
      <div class="w-1/3 max-w-[100px] mr-2.5">
        <app-image [alt]="_line.recipe?.displayname" size="md" [src]="_line.recipe?.websitemediumimageurl" class="rounded-md"></app-image>
      </div>
    }
    <div class="flex flex-col" [ngClass]="layout === 'CONDENSED' ? 'px-2.5 py-[15px] basis-[130px] shrink-0': 'w-2/3 grow'">
      <div class="flex flex-row justify-between">
        <div class="mr-2.5">
          <small>
            <strong class="text-e-dark-green">
              {{_line.recipe?.displayname}}
            </strong>
          </small>
          @if (layout !== 'ORDERFLOW') {
            <small class="line-clamp-2 text-e-dark-green flex">{{_line.recipe?.subtitle}}</small>
          }
        </div>
        @if (removable) {
          <button class="min-w-4 min-h-5 mt-2 self-start" (click)="removeRecipeline()">
            @if (layout === 'NORMAL') {
              <img src="./assets/images/icons/delete.svg" height="20px" width="16px" alt="delete" />
            }
            @if (layout === 'ORDERFLOW') {
              <i class="bi bi-x-circle"></i>
            }
          </button>
        }
      </div>

      @switch (layout) {
        @case ('NORMAL') {
          <div class="mt-[15px] flex flex-row items-end justify-between">
            <app-personselection class="max-w-[175px] w-full md:w-3/5" [contrastColorscheme]="colorscheme" small [persons]="_line.persons" [editable]="editable" (personsChange)="changePersonQty($event)">
              <span>{{'common.person_abbr'|translate}}</span>
            </app-personselection>
            @if (removable) {
              <pricetag [calculatedPrice]="_line?.calculatedPrice" [couponcodeItem]="_line?.couponcodeitem" [compensationItem]="_line?.compensationitem" [hideSmallTag]="hidePriceSmallTag"></pricetag>
            }
          </div>
        }
        @case ('CONDENSED') {
          <div class="col-6 text-nowrap px-0">
            <small>{{_line.doublepersons? _line.persons * 2 : _line.persons}} {{'common.person_abbr'|translate}}</small>
          </div>
        }
        @case ('ORDERFLOW') {
          <div class="mt-[15px] flex flex-row flex-wrap items-end justify-between">
            <div class="flex flex-row gap-1">
              <pricetag [calculatedPrice]="_line?.calculatedPrice" [couponcodeItem]="_line?.couponcodeitem" [compensationItem]="_line?.compensationitem" [hideSmallTag]="hidePriceSmallTag"></pricetag>
              <small class="self-end text-gray-400">{{_line?.calculatedPrice?.priceincvat / (_line.doublepersons ? _line.persons * 2 : _line.persons) | currency : 'EUR'}} /{{'common.person_abbr'|translate}}</small>
            </div>
            <app-personselection class="max-w-[175px] w-full md:w-2/5" [contrastColorscheme]="colorscheme" small [persons]="_line.persons" (personsChange)="changePersonQty($event)" [editable]="editable">
              <span>{{'common.person_abbr'|translate}}</span>
            </app-personselection>
          </div>
        }
      }
    </div>
  </div>
}
